import { Toast } from 'angular2-toaster';
import { SECONDS } from '@config/global-constants';
import { I18n } from '@app/i18n/strings-keys';

export const LIST_VIEW_OPERATION_SUCCESS: Toast = {
  type: 'success',
  body: I18n.InfoMessages.ViewOperationCompletedSuccessfully,
  timeout: 2 * SECONDS,
};

export const LIST_VIEW_OPERATION_ERROR: Toast = {
  type: 'warning',
  body: I18n.ErrorMessages.ViewOperationFailed,
  timeout: 2 * SECONDS,
};

export const CLIPBOARD_ACCESS_WARNING: Toast = {
  type: 'warning',
  body: I18n.ErrorMessages.UnableToAccessClipboard,
  timeout: 2 * SECONDS,
};
